module.exports = __webpack_public_path__ + "img/fieldwork-2018-yonglian.3856b231.jpg";